import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Subject, Subjects } from './@define/type';

const initialState = {
  page: 0,
  list: {
    subjects: [] as Subjects,
    total_count: 0,
  } as any,
  detail: {} as Subject,
  selected: {} as Subject,
};

const subjectSlice = createSlice({
  name: 'subject',
  initialState,
  reducers: {
    createSubject: (_state, _action: PayloadAction<{ data: any }>) => undefined,
    requestSubjects: (_state, _action: PayloadAction<{ page?: number; limit?: number }>) => {},
    saveSubjects: (state, action: PayloadAction<{ list: any }>) => {
      const { list } = action.payload;
      state.list = list;
    },
    selectSubject: (state, action: PayloadAction<{ data: any }>) => {
      state.selected = action.payload.data;
    },
    requestSubject: (_state, _action: PayloadAction<{ id: any }>) => undefined,
    saveSubject: (state, action: PayloadAction<{ data: any }>) => {
      state.detail = action.payload.data;
    },
    updateSubject: (_state, _action: PayloadAction<{ data: any }>) => undefined,
    deleteSubject: (_state, _action: PayloadAction<{ data: any }>) => undefined,
    resetSubject: () => initialState,
  },
});

export default subjectSlice;
